import { Col, Form, Input, Row, Select, Tooltip } from "antd";

interface RoleAssignmentsProps {
	item: any;
	dataObject: any;
	setFormReset: any;
	disabled: boolean;
	handleSelectOptions: any;
	renderLookupMissing: any;
	disabledTooltipMessage: string;
	readOnly: boolean;
	filterOption: any;
}

function RoleAssignments({
	disabled,
	item,
	dataObject,
	setFormReset,
	handleSelectOptions,
	renderLookupMissing,
	disabledTooltipMessage,
	readOnly,
	filterOption,
}: RoleAssignmentsProps) {
	const [column1, column2] = item.children;

	return (
		<div>
			<Form.List name={item.name}>
				{(fields) => (
					<>
						<Row gutter={[12, 12]}>
							<Col span={12}>
								<Form.Item>{column1.label}</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item>{column2.label}</Form.Item>
							</Col>
						</Row>
						{fields.map(({ key, name, ...restField }) => (
							<Row key={key} gutter={[12, 12]}>
								<>
									<Col span={12}>
										<Form.Item
											key={column1.uniqueKeyName}
											{...restField}
											name={[name, column1.name]}
											rules={[
												{
													required: true,
													message: "",
												},
											]}
										>
											<Input disabled />
											{renderLookupMissing(
												"role_assignments",
												name,
												column1.uniqueKeyName,
												{ ...restField }
											)}
										</Form.Item>
									</Col>

									<Col span={12}>
										<Tooltip
											title={
												disabled && disabledTooltipMessage
													? disabledTooltipMessage
													: ""
											}
										>
											<Form.Item
												{...restField}
												name={[name, column2.name]}
												rules={[
													{
														required: true,
														message: "",
													},
												]}
												style={{
													flex: 1,
												}}
											>
												<Select
													getPopupContainer={(trigger: any) =>
														trigger.parentNode
													}
													allowClear
													disabled={disabled || readOnly}
													mode={column2.mode || undefined}
													filterOption={filterOption}
													showSearch
													options={handleSelectOptions(
														column2.name,
														column2.optionKey,
														column2.optionLabel,
														column2.extraKey
															? dataObject?.[column2.extraKey]
															: null,
														column2.relayFrom,
														column2.dependsOn,
														"normal"
													)}
													onChange={() => setFormReset(false)}
													placeholder={column2.placeholder || "Please select"}
												/>
											</Form.Item>
										</Tooltip>
									</Col>
								</>
							</Row>
						))}
					</>
				)}
			</Form.List>
		</div>
	);
}

export default RoleAssignments;
